import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { initWebVitals } from './lib/webVitals'
import { initAnalytics, trackPageViews } from './lib/analytics'
import { enableScrollToTopOnNavigate } from './lib/scroll'
import { router } from './routes'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Kick off Core Web Vitals reporting after render. Fires asynchronously so
// it never blocks first paint. Forwards LCP/INP/CLS/FCP/TTFB to GA so we
// can see regressions on the Real Experience report and on PageSpeed.
initWebVitals()

// Install the delegated click listener for conversion tracking — captures
// signup-CTA clicks and contact-sales mailto clicks across the marketing
// site without onClick boilerplate on every Link. Idempotent under
// StrictMode's double-invoke.
initAnalytics()

// Manual SPA page_view tracking. GA4's automatic page_view only fires
// on hard reloads, so every cross-route navigation (Landing -> blog
// post, blog -> next blog) is invisible to analytics without this.
trackPageViews(router)

// Scroll to top on every link click / programmatic navigate. React
// Router preserves scroll by default which is the wrong default for a
// marketing site — see lib/scroll.ts for the full policy (skips back/
// forward and hash anchors).
enableScrollToTopOnNavigate(router)
